import Axios from '@/axios'

// 查询用户
// 接口权限名：web:userManager-user:index
export const GetUsers = data => {
  return Axios({
    url: '/device-manager/web/uem/user-manager/index',
    method: 'POST',
    type: 'json',
    data
  })
}

// 新增用户
// 接口权限名：web:user:create
export const NewUser = data => {
  return Axios({
    url: '/device-manager/admin-web/user/create_user',
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改用户
// 接口权限名：web:user:update
export const EditUser = data => {
  return Axios({
    url: `/device-manager/admin-web/user/update_user/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除用户
// 接口权限名：web:user:delete
export const DeleteUser = data => {
  return Axios({
    url: `/device-manager/admin-web/user/delete_user/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 查询某个用户所属用户组
// 接口权限名：web:userGroup-divide:indexForUser
export const GetUserDivide = params => {
  return Axios({
    url: `/device-manager/admin-web/user-divide/index/${params.id}`,
    method: 'GET',
    type: 'json',
    params
  })
}

// 将某个用户 加入\退出 某个用户组
// 接口权限名：web:userDivide:change
export const SetUserDivide = data => {
  return Axios({
    url: '/device-manager/web/uem/user-group/user_divide',
    method: 'POST',
    type: 'json',
    data
  })
}

// 查询用户操作日志
// 接口权限名：web:managerLog:index
export const GetUserLogs = data => {
  return Axios({
    url: '/device-manager/web/uem/operation-log/index',
    method: 'POST',
    type: 'json',
    data
  })
}




